/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  CancelEncounterErrorResponse,
  CancelEncounterRequest,
  CancelEncounterResponse,
} from './api.schemas';

import { api } from '../util/http';

export const createEncountersCancel = (
  encounterId: number,
  cancelEncounterRequest: CancelEncounterRequest,
  signal?: AbortSignal,
) => {
  return api<CancelEncounterResponse>({
    url: `/api/encounters/${encounterId}/cancel`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: cancelEncounterRequest,
    signal,
  });
};

export const getCreateEncountersCancelMutationOptions = <
  TError = CancelEncounterErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEncountersCancel>>,
    TError,
    { encounterId: number; data: CancelEncounterRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEncountersCancel>>,
  TError,
  { encounterId: number; data: CancelEncounterRequest },
  TContext
> => {
  const mutationKey = ['createEncountersCancel'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEncountersCancel>>,
    { encounterId: number; data: CancelEncounterRequest }
  > = (props) => {
    const { encounterId, data } = props ?? {};

    return createEncountersCancel(encounterId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEncountersCancelMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEncountersCancel>>
>;
export type CreateEncountersCancelMutationBody = CancelEncounterRequest;
export type CreateEncountersCancelMutationError = CancelEncounterErrorResponse;

export const useCreateEncountersCancel = <
  TError = CancelEncounterErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEncountersCancel>>,
      TError,
      { encounterId: number; data: CancelEncounterRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEncountersCancel>>,
  TError,
  { encounterId: number; data: CancelEncounterRequest },
  TContext
> => {
  const mutationOptions = getCreateEncountersCancelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
